export const categories = {
  label: 'Supplier Category',
  key: 'brand_category',
  icon: 'pulse',
  tooltip: 'This is a tooltip'
}
